var path = 'src/app/components/administration/users/branches/users-branches.template.html';
var html = "<branches-list detail-link=\"/#!/admin/organization/users\"></branches-list>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;